// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyDNuE3Oc7b-q__oYNEytWPfzdwUJ-1iFv0",
  authDomain: "diya-furnitures.firebaseapp.com",
  projectId: "diya-furnitures",
  storageBucket: "diya-furnitures.appspot.com",
  messagingSenderId: "1000754602524",
  appId: "1:1000754602524:web:f3a006e4948caa8602f5d9"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export default app; 